function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_87",
  "data-name": "Path 87",
  d: "M0,0H16V16H0Z",
  fill: "none"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "bolt_black_24dp",
  d: "M9.646,14.9H8.985l.661-4.629H7.332c-.384,0-.377-.212-.251-.436s.033-.053.046-.079Q8.406,7.5,10.969,3h.661l-.661,4.629h2.314c.324,0,.37.218.311.337l-.046.1Q9.64,14.9,9.646,14.9Z",
  transform: "translate(-2.31 -0.951)",
  fill: "#4d4d4d"
});

function SvgInsulationFlangeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "more_vert-24px",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsulationFlangeIcon);
export default __webpack_public_path__ + "static/media/insulationFlangeIcon.060c0c15.svg";
export { ForwardRef as ReactComponent };